import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import axiosNoLoading from "../../shared/utils/axiosNoLoading";
import { FileShareLinkPolicy } from "../../types/files";
import { NotificationDTO, Policy } from "../../types/workgroup";

const GATEWAY_URL = config.servers.gateway.url;

export interface SetGetPolicyReqDTO {
  syncId: string;
  workgroupId: string;
  setPolicyDTO?: Policy[];
  fileShareLinkPolicy?: FileShareLinkPolicy;
  actionUrl?: string;
  sendShareMail?: boolean; //(true : 메일 전송 / false : 메일 미전송)
  message?: string;
}

interface PolicyApi {
  setPolicy(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]>;
  getPolicy(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]>;
  setPolicies(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]>;
  setFileLinkPolicy(reqDTO: SetGetPolicyReqDTO): Promise<SetGetPolicyReqDTO>;
  getFileLinkPolicy(reqDTO: SetGetPolicyReqDTO): Promise<SetGetPolicyReqDTO>;
  checkFilePWValid(reqDTO: {
    uuid: string;
    password: string;
  }): Promise<{ apiToken: string }>;
  getPolicyNoti(): Promise<NotificationDTO>;
  updatePolicyNoti(req: NotificationDTO): Promise<NotificationDTO>;
  getMSAppConfig(): Promise<
    {
      appName: string;
      favIconUrl: string;
      extensions: string[];
    }[]
  >;
}

class PolicyServerApi implements PolicyApi {
  async setPolicy(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]> {
    const resp =
      reqDTO.sendShareMail !== undefined
        ? await axios.post<Policy[]>(
            `${GATEWAY_URL}/wapi/policy/${reqDTO.syncId}/${reqDTO.workgroupId}/execute`,
            {
              policyList: reqDTO.setPolicyDTO,
              sendShareMail: reqDTO.sendShareMail ?? false,
              message: reqDTO.message ?? "",
            }
          )
        : await axios.post<Policy[]>(
            `${GATEWAY_URL}/wapi/policy/${reqDTO.syncId}/${reqDTO.workgroupId}`,
            reqDTO.setPolicyDTO
          );
    return Promise.resolve(resp.data);
  }
  async getPolicy(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]> {
    const resp = await axios.get<Policy[]>(
      `${GATEWAY_URL}/wapi/policy/${reqDTO.workgroupId}/${reqDTO.syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async setPolicies(reqDTO: SetGetPolicyReqDTO): Promise<Policy[]> {
    const resp = await axiosNoLoading.post<Policy[]>(
      `${GATEWAY_URL}/wapi/policy/reset/` +
        reqDTO.syncId +
        "/" +
        reqDTO.workgroupId,
      reqDTO.setPolicyDTO
    );

    return Promise.resolve(resp.data);
  }
  async setFileLinkPolicy(
    reqDTO: SetGetPolicyReqDTO
  ): Promise<SetGetPolicyReqDTO> {
    const resp = await axios.post<SetGetPolicyReqDTO>(
      `${GATEWAY_URL}/wapi/policy/actionUrl/${reqDTO.workgroupId}/${reqDTO.syncId}`,
      { fileShareLinkPolicy: reqDTO.fileShareLinkPolicy }
    );
    return Promise.resolve(resp.data);
  }
  async getFileLinkPolicy(
    reqDTO: SetGetPolicyReqDTO
  ): Promise<SetGetPolicyReqDTO> {
    const resp = await axios.get<SetGetPolicyReqDTO>(
      `${GATEWAY_URL}/wapi/policy/actionUrl/${reqDTO.workgroupId}/${reqDTO.syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async checkFilePWValid(reqDTO: {
    uuid: string;
    password: string;
  }): Promise<{ apiToken: string }> {
    const resp = await axios.post<{ apiToken: string }>(
      `${GATEWAY_URL}/papi/actionUrl/valid`,
      reqDTO
    );
    return Promise.resolve(resp.data);
  }
  async getPolicyNoti(): Promise<NotificationDTO> {
    const resp = await axios.get<NotificationDTO>(
      `${GATEWAY_URL}/wapi/policy/notification/myInfo`
    );
    return Promise.resolve(resp.data);
  }
  async updatePolicyNoti(req: NotificationDTO): Promise<NotificationDTO> {
    const resp = await axios.post<NotificationDTO>(
      `${GATEWAY_URL}/wapi/policy/notification/myInfo`,
      { workgroupId: "", notificationPolicy: req }
    );
    return Promise.resolve(resp.data);
  }
  async getMSAppConfig(): Promise<
    {
      appName: string;
      favIconUrl: string;
      extensions: string[];
    }[]
  > {
    const resp = await axios.get<
      {
        appName: string;
        favIconUrl: string;
        extensions: string[];
      }[]
    >(`${GATEWAY_URL}/papi/public/wopi/apps/config`);
    return Promise.resolve(resp.data);
  }
}

const policyApi: PolicyApi = new PolicyServerApi();
export default policyApi;
